var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-731.000000, -827.000000)",
    stroke: "#A17D58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(512.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3870968,30.6451613 L48.3870968,48.3870968 C48.3870968,49.2774194 47.6645161,50 46.7741935,50 L3.22580645,50 C2.33548387,50 1.61290323,49.2774194 1.61290323,48.3870968 L1.61290323,30.6451613",
    id: "Stroke-1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7096774,4.83870968 L13.7096774,3.22580645 C13.7096774,3.22580645 16.9354839,0 25,0 C33.0645161,0 36.2903226,3.22580645 36.2903226,3.22580645 L36.2903226,4.83870968",
    id: "Stroke-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7741935,22.5806452 C22.5806452,24.1935484 24.1935484,24.1935484 24.1935484,24.1935484 L25.8064516,24.1935484 C27.1370968,24.1935484 28.2258065,23.1048387 28.2258065,21.7741935 C28.2258065,20.4435484 27.1370968,19.3548387 25.8064516,19.3548387 L24.1935484,19.3548387 C22.8629032,19.3548387 21.7741935,18.266129 21.7741935,16.9354839 C21.7741935,15.6048387 22.8629032,14.516129 24.1935484,14.516129 L25.8064516,14.516129 C25.8064516,14.516129 27.4193548,14.516129 28.2258065,16.1290323",
    id: "Stroke-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,12.9032258 L25,14.516129",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24.1935484 L25,25.8064516",
    id: "Stroke-9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6129032,38.7096774 L23.3870968,38.7096774 C22.4967742,38.7096774 21.7741935,37.9870968 21.7741935,37.0967742 L21.7741935,32.2580645 C21.7741935,31.3677419 22.4967742,30.6451613 23.3870968,30.6451613 L26.6129032,30.6451613 C27.5032258,30.6451613 28.2258065,31.3677419 28.2258065,32.2580645 L28.2258065,37.0967742 C28.2258065,37.9870968 27.5032258,38.7096774 26.6129032,38.7096774 Z",
    id: "Stroke-11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2258065,33.7441935 C37.7395161,33.0635484 50,29.8385484 50,29.8385484 L50,9.67725806 C50,8.78693548 49.2774194,8.06435484 48.3870968,8.06435484 L1.61290323,8.06435484 C0.722580645,8.06435484 0,8.78693548 0,9.67725806 L0,29.8385484 C0,29.8385484 12.2604839,33.0635484 21.7741935,33.7441935",
    id: "Stroke-13",
    strokeLinecap: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon6);
export default __webpack_public_path__ + "static/media/product-icon6.5d683e45e51d1f9e2edcc5bf6c664016.svg";
export { ForwardRef as ReactComponent };